// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Env = require("./reason/common/Env.bs.js");
var AuthSession = require("./utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RelayRuntime = require("relay-runtime");
var Caml_exceptions = require("rescript/lib/js/caml_exceptions.js");
var GraphQLWSClient = require("./GraphQLWSClient.bs.js");

var Graphql_error = /* @__PURE__ */Caml_exceptions.create("RelayEnv.Graphql_error");

async function fetchQuery(operation, variables, _cacheConfig, _uploadables) {
  var match = operation.text;
  if (!Array.isArray(match) && (match === null || typeof match !== "object") && typeof match !== "number" && typeof match !== "string" && typeof match !== "boolean") {
    return Object.fromEntries([[
                  "data",
                  Object.fromEntries([])
                ]]);
  }
  var token = await AuthSession.getWithExpiryCheck(operation.name);
  var headers = Core__Array.keepSome([
        [
          "content-type",
          "application/json"
        ],
        [
          "accept",
          "application/json"
        ],
        token !== undefined ? [
            "Authorization",
            "Bearer " + token
          ] : undefined
      ]);
  var resp = await fetch(Env.apiPath + "/graphql", {
        method: "POST",
        body: Caml_option.some(JSON.stringify(Object.fromEntries([
                      [
                        "query",
                        operation.text
                      ],
                      [
                        "variables",
                        variables
                      ],
                      [
                        "operationName",
                        operation.name
                      ]
                    ]))),
        headers: Caml_option.some(new Headers(headers))
      });
  if (resp.ok) {
    return await resp.json();
  }
  throw {
        RE_EXN_ID: Graphql_error,
        _1: "Request failed: " + resp.statusText,
        Error: new Error()
      };
}

var network = RelayRuntime.Network.create(fetchQuery, Caml_option.option_get(Core__Option.map(GraphQLWSClient.client, (function (wsClient) {
                return function (operation, variables, _cacheConfig) {
                  var subscriptionQuery_operationName = operation.name;
                  var subscriptionQuery_query = operation.text;
                  var subscriptionQuery = {
                    operationName: subscriptionQuery_operationName,
                    query: subscriptionQuery_query,
                    variables: variables
                  };
                  return RelayRuntime.Observable.create(function (sink) {
                              var unsubscribe = wsClient.subscribe(subscriptionQuery, sink);
                              return {
                                      unsubscribe: unsubscribe,
                                      closed: false
                                    };
                            });
                };
              }))));

var environment = RescriptRelay.Environment.make(network, RescriptRelay.Store.make(new RelayRuntime.RecordSource(), 10, undefined), (function (nodeObj, param) {
        return nodeObj.nodeId;
      }), undefined, undefined, undefined, undefined);

exports.environment = environment;
/* network Not a pure module */
